import { createSessionMarker } from './sessionMarker'

// Shared state between the chunk-reload plugin (writes) and the APM plugin (reads),
// so chunk errors can be labeled with whether a recovery reload answered them and
// the following page load can be labeled as a completed recovery.

// 10s TTL mirrors reloadNuxtApp's own per-path reload guard.
const marker = createSessionMarker('core:chunk-reload', 10_000)

const isChunkErrorMessage = (message?: string): boolean =>
    /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message ?? '')

let reloadTriggered = false

/** Record whether a chunk-error recovery attempt actually triggered a reload. */
export const markChunkRecovery = (triggered: boolean): void => {
    reloadTriggered = triggered
    if (!triggered) return
    marker.mark()
}

interface ApmErrorEvent {
    exception?: {
        message?: string
    }
    context?: {
        tags?: Record<string, unknown>
    }
}

interface ApmPayload {
    errors?: ApmErrorEvent[]
}

/** APM filter: label chunk errors with whether a recovery reload answered them. */
export const labelRecoveredChunkErrors = <T extends ApmPayload>(payload: T): T => {
    payload.errors?.forEach((error) => {
        if (!isChunkErrorMessage(error.exception?.message)) return
        error.context = { ...error.context, tags: { ...error.context?.tags, chunk_error_recovered: reloadTriggered } }
    })
    return payload
}

/** Read and clear the marker set before a recovery reload; true when this page load is a fresh one. */
export const consumeChunkRecoveryMarker = (): boolean => marker.consume()
